export default {
    methods: {
        openRemoveModal() {
            EventBus.fire('open-cart-remove-modal', this.item);
        }
    }
}
